import React from "react";
import { IonIcon } from "@ionic/react";
import { warningOutline } from "ionicons/icons";
import { TTaxiShippingWarning } from "@core/types";
import { useTranslation } from "react-i18next";

interface DeliveryWarningsProps {
  warnings: TTaxiShippingWarning[];
}

const formatWarningText = (warning: TTaxiShippingWarning, t: (key: string) => string): string => {
  const { message, delayMin, delayMax } = warning;

  if (delayMin != null && delayMax != null) {
    return t("deliveryWarningWithDelayRange")
      .replace("{{message}}", message)
      .replace("{{min}}", String(delayMin))
      .replace("{{max}}", String(delayMax));
  }

  if (delayMin != null) {
    return t("deliveryWarningWithDelayMin")
      .replace("{{message}}", message)
      .replace("{{min}}", String(delayMin));
  }

  if (delayMax != null) {
    return t("deliveryWarningWithDelayMax")
      .replace("{{message}}", message)
      .replace("{{max}}", String(delayMax));
  }

  return message;
};

export const DeliveryWarnings = ({ warnings }: DeliveryWarningsProps) => {
  const { t } = useTranslation();

  if (!warnings.length) {
    return null;
  }

  return (
    <div className="mt-1 flex flex-col gap-0.5">
      {warnings.map((warning, index) => (
        <div
          key={`${warning.code ?? warning.message}-${index}`}
          className="flex items-center gap-1.5 font-bold"
        >
          <IonIcon icon={warningOutline} className="h-[18px] w-[18px] shrink-0 text-[#656565]" />
          <span className="flex-1 text-xs leading-[18px] text-[#656565]">
            {formatWarningText(warning, t)}
          </span>
        </div>
      ))}
    </div>
  );
};
